<!--
 * @Description: 
 * @Date: 2023-04-12 14:30:35
 * @LastEditTime: 2023-05-16 09:40:04
 * @FilePath: \lims-platform\src\views\components\JSelectflowpathCheck.vue
-->
<template>
    <!-- 定义在这里的参数都是不可在外部覆盖的，防止出现问题 -->
    <j-select-biz-component :value="value" :ellipsisLength="25" :listUrl="url.list" :columns="columns" v-on="$listeners" v-bind="attrs" :multiple="false" />
</template>

<script>
import JDate from '@comp/jeecg/JDate'
import JSelectBizComponent from './JSelectBizComponent'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil';
import { categoryList } from "@views/flowable/api/definition";

export default {
    name: 'JSelectFlowpathCheck',
    components: { JDate, JSelectBizComponent },
    props: {
        value: null, // any type
        queryConfig: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            url: { list: '/flowable/definition/list?isLastVersion=1' },
            categorys: [],
            // 定义在这里的参数都是可以在外部传递覆盖的，可以更灵活的定制化使用的组件
            default: {
                name: this.$t('流程定义'),
                width: 1200,
                displayKey: 'name',
                returnKeys: ['key', 'key'],
                queryParamText: this.$t('流程名称'),
            },
            // 多条件查询配置
            queryConfigDefault: [
                {
                    key: 'category',
                    label: this.$t('流程分类'),
                    dictCode: 'flow_category'
                    // 如果包含 dictCode，那么就会显示成下拉框
                },
            ],
        }
    },
    computed: {
        // 表头
        columns() {
            return [
                { title: this.$t('流程名称'), align: 'center', width: '25%', widthRight: '70%', dataIndex: 'name' },
                { title: this.$t('流程标识key'), align: 'center', width: '25%', dataIndex: 'key' },
                {
                    title: this.$t('流程分类'), align: 'center', width: '20%', dataIndex: 'category', customRender: (text, record, index) => {

                        console.log("record", record);
                        console.log("index", index);
                        //字典值翻译通用方法
                        return this.getCategoryName(text)
                        // return filterDictTextByCache('flow_category', index);
                    }
                },
                {
                    title: this.$t('状态'), align: 'center', width: '20%', dataIndex: 'suspensionState', customRender: (text) => {
                        //字典值翻译通用方法
                        return text == 1 ? this.$t('激活') : this.$t('挂起');
                    }
                }
            ]
        },
        attrs() {
            return Object.assign(this.default, this.$attrs, {
                queryConfig: this.queryConfigDefault.concat(this.queryConfig)
            })
        }
    },
    created() {
        this.initUserAndRole();
    },
    methods: {
        initUserAndRole() {
            categoryList({ dictId: "1658010206426996738" }).then(res => {
                let Array = res.result.records || []
                this.categorys = Array
            })
        },
        getCategoryName(category) {
            let find = this.categorys.find(o => o.id == category);
            if (find) {
                return find.itemText
            }
            return ''
        },
    }
}
</script>

<style lang="less" scoped></style>